import { EnergyGrade, HeatingGrade } from 'enova-frontend-components';

export enum Energimerkeversjon {
  V2023 = 'v2023',
  V2025 = 'v2025'
}

export type EnergimerkeV2023 = {
  oppvarmingskarakter?: HeatingGrade;
  energikarakter?: EnergyGrade;
  version: Energimerkeversjon.V2023;
};

export type EnergimerkeV2025 = {
  energikarakter?: EnergyGrade;
  version: Energimerkeversjon.V2025;
};

export type Energimerke = EnergimerkeV2023 | EnergimerkeV2025;
